import { axios } from "utils";

import { ADMIN_PARTNERS_URL as endpoint } from "consts";

import { AllPartnersResponse, Partner } from "models";

// admin

export const attachFarm = async (data: never): Promise<never> => axios.post(`${endpoint}/farmers/attach`, { data });

export const detachFarm = async (data: never): Promise<never> => axios.post(`${endpoint}/farmers/detach`, { data });

export const addPartner = async (data: never): Promise<never> => axios.post(`${endpoint}`, { data });

export const getAllPartners = async (): Promise<AllPartnersResponse> => axios.get(endpoint);

export const getPartner = async ({ id }: { id: string }): Promise<Partner> => axios.get(`${endpoint}/${id}`);

export const updatePartner = async (data: { id: string; [key: string]: unknown }): Promise<void> => axios.put(`${endpoint}/${data.id}`, { data });

export const addCreditPurchase = async (data: { partnerId: string }): Promise<never> => axios.post(`${endpoint}/${data.partnerId}/credit-purchases`, { data });

export const getCreditPurchase = async (data: { id: string }): Promise<never> => axios.get(`${endpoint}/credit-purchases/${data.id}`, { data });

export const updateCreditPurchase = async (data: { id: string }): Promise<never> => axios.put(`${endpoint}/credit-purchases/${data.id}`, { data });

export const getPartnerFarmers = async (data: { partnerId: string }): Promise<never> => axios.get(`${endpoint}/${data.partnerId}/farmers/`, { data });

export const getPartnerCreditAssignments = async (data: { id: string }): Promise<never> => axios.get(`${endpoint}/${data.id}/credit-assignments`, { data });

export const getPartnerCreditPurchases = async (data: { id: string }): Promise<never> => axios.get(`${endpoint}/${data.id}/credit-purchases`, { data });

export const unassignCredit = async (data: { assignmentId: string }): Promise<never> =>
  axios.delete(`${endpoint}/credit-assignments/${data.assignmentId}`, {
    data,
  });

export const updateAssignedCredit = async (data: { assignmentId: string }): Promise<never> =>
  axios.put(`${endpoint}/credit-assignments/${data.assignmentId}`, {
    data,
  });

export const deleteCreditPurchase = async (data: { purchaseId: string }): Promise<never> =>
  axios.delete(`${endpoint}/credit-purchases/${data.purchaseId}`, {
    data,
  });
